<template>
  <div>
    <main-layout>
      <div class="pl-4">
        <v-tabs
          v-model="viewPage"
          color="white"
          :slider-color="$vuetify.theme.primary"
          style="font-size: 18px"
        >
          <v-tab
            v-for="(item, index) in menuItem"
            :key="`menu-item-${index}`"
            style="text-transform: capitalize"
            ripple
            :href="`#${item.view}`"
            @click="updateSlug(item.view)"
            >{{ item.text }}</v-tab
          >
        </v-tabs>
      </div>
      <div>
        <GeneralSetting v-if="view == 'generalSetting'" />
        <Notification v-else-if="view == 'notification'" />
        <LineChatbot v-else-if="view == 'lineChatbot'" />
      </div>
    </main-layout>
  </div>
</template>
  
  <script>
import GeneralSetting from './GeneralSetting'
import Notification from './Notification'
import LineChatbot from './LineChatbot'

export default {
  components: {
    GeneralSetting,
    Notification,
    LineChatbot,
  },
  data() {
    return {
      menuData: [
        {
          text: 'ตั้งค่าทั่วไป',
          view: 'generalSetting',
        },
        {
          text: 'การแจ้งเตือน',
          view: 'notification',
        },
        {
          text: 'Line Chatbot',
          view: 'lineChatbot',
        },
      ],
      viewPage: 'generalSetting',
    }
  },
  mounted() {},
  computed: {
    menuItem() {
      // if (this.$store.state.privilege && this.$store.state.privilege.role == 'agency') {
      //   return this.menuData.filter((el) => {
      //     return ['couponreport', 'techproviderandproductreport'].includes(el.view)
      //   })
      // } else {
        return this.menuData
      // }
    },
    view() {
      var defaultview = 'generalSetting'
      // if (this.$store.state.privilege && this.$store.state.privilege.role == 'agency') {
      //   defaultview = 'couponreport'
      // }
      this.viewPage = this.$route.query.view ? this.$route.query.view : defaultview
      return this.$route.query.view ? this.$route.query.view : defaultview
    },
  },
  methods: {
    updateSlug(view) {
      if (view !== this.view) {
        this.$router.replace({ query: { view } })
      }
    },
  },
}
</script>
  
  <style lang="scss" scoped>
.border-bot {
  border-bottom: 2px solid #152d53;
}
</style>
  


// WEBPACK FOOTER //
// src/components/view/billing/main.vue